import { useStorageReducer } from "@/hooks/customHooks";
import type { TodoType, DayType, Action } from "@/types/types";
import { useEffect, useMemo } from "react";
import Day from "./Day";
import { todosReducer } from "@/reducers/reducers";

function getDays() {
  const days: DayType[] = [];
  const today = new Date();
  for (let i = 0; i < 7; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() + i);
    days.push({ date, todos: [] });
  }
  return days;
}

export default function Calendar() {
  const [todos, dispatchTodos] = useStorageReducer<TodoType[], Action>(
    todosReducer,
    [],
    "todoot-todos",
  );

  useEffect(() => {
    dispatchTodos({ type: "dateUpdate" });
  }, []);

  const days = useMemo(() => {
    const baseDays = getDays();

    return baseDays.map((day) => {
      const dayTodos = todos.filter((todo) => {
        const todoDate = new Date(todo.doneBy);
        return (
          todoDate.getDate() === day.date.getDate() &&
          todoDate.getMonth() === day.date.getMonth() &&
          todoDate.getFullYear() === day.date.getFullYear()
        );
      });

      return { ...day, todos: dayTodos };
    });
  }, [todos]);

  return (
    <>
      {days.map((day, index) => (
        <Day
          index={index}
          key={day.date.getDate()}
          day={day}
          dispatch={dispatchTodos}
        />
      ))}
    </>
  );
}
